import React from 'react';
import { SunIcon, MoonIcon } from '@heroicons/react/24/outline';
import { useTheme } from '../../contexts/ThemeContext';

const ThemeToggle = () => {
  const { resolvedTheme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="relative p-2 rounded-lg bg-slate-200/50 dark:bg-slate-800/50 border border-slate-300/50 dark:border-slate-700/50 hover:bg-slate-300/50 dark:hover:bg-slate-700/50 transition-colors duration-200"
      aria-label="Toggle theme"
    >
      <div className="w-5 h-5">
        {resolvedTheme === 'dark' ? (
          <SunIcon className="w-5 h-5 text-yellow-400" />
        ) : (
          <MoonIcon className="w-5 h-5 text-slate-600" />
        )}
      </div>
    </button>
  );
};

export default ThemeToggle;
